import React, { useEffect, useState } from "react";
import { Timeline } from "primereact/timeline";
import { Card } from "primereact/card";
import { Chip } from "primereact/chip";
import { events, JobEvent } from "./data";
import { Inplace, InplaceContent, InplaceDisplay } from "primereact/inplace";
import { Img } from "react-image";

const techIconContent = (imgSrc: string, label: string) => (
  <>
    <span className="border-circle w-2rem h-2rem flex align-items-center justify-content-center">
      <Img className="bg-white" src={imgSrc} alt={label} />
    </span>
    <span className="font-medium">{label}</span>
  </>
);

export default function TimelineCv() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    // Function to update state based on window size
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Cleanup function to remove event listener
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const customizedMarker = (item: JobEvent) => <Chip label={item.year} />;

  const customizedContent = (item: JobEvent) => {
    return (
      <Card
        className="mt-2 mb-2 text-left"
        title={item.title}
        subTitle={item.subtitle}
      >
        <div className="mb-3">
          <div className="text-2xl flex align-items-center mb-1 text-primary">
            <i className="pi pi-bolt mr-1 text-xl" />
            Storia
          </div>
          <div>{item.reason}</div>
        </div>
        <div className="mb-3">
          <div className="text-2xl flex align-items-center mb-1 text-primary">
            <i className="pi pi-cog mr-1 text-xl" />
            Progetto
          </div>
          <div>{item.project}</div>
        </div>
        <div className="mb-3">
          <div className="text-2xl flex align-items-center mb-1 text-primary">
            <i className="pi pi-lightbulb mr-1 text-xl" />
            Apprendimenti
          </div>
          <div>{item.learnings}</div>
        </div>
        <div className="mb-3">
          <div className="text-2xl flex align-items-center mb-1 text-primary">
            <i className="pi pi-euro mr-1 text-xl" />
            Stipendio & Tempo
          </div>
          <div>{item.salary}</div>
        </div>
        <div>
          <div className="text-2xl flex align-items-center mb-1 text-primary">
            <i className="pi pi-microchip mr-1 text-xl" />
            Tecnologie
          </div>
          <div className="mt-2">
            <Inplace className="flex align-items-center justify-content-center">
              <InplaceDisplay>
                <span className="font-bold">Mostra tecnologie applicative</span>
              </InplaceDisplay>
              <InplaceContent>
                <div className="text-xl mb-2 text-primary">
                  Applicazioni e dati
                </div>
                {item.technologies.map((tech, index) => (
                  <Chip
                    key={index}
                    className="mr-2 mb-2"
                    template={techIconContent(tech.imgSrc, tech.label)}
                  />
                ))}

                <div className="text-xl mb-2 mt-1 text-primary">Utilità</div>
                {item.utilities.map((tech, index) => (
                  <Chip
                    key={index}
                    className="mr-2 mb-2"
                    template={techIconContent(tech.imgSrc, tech.label)}
                  />
                ))}

                {item.devOps.length > 0 && (
                  <>
                    <div className="text-xl mb-2 mt-1 text-primary">DevOps</div>
                    {item.devOps.map((tech, index) => (
                      <Chip
                        key={index}
                        className="mr-2 mb-2"
                        template={techIconContent(tech.imgSrc, tech.label)}
                      />
                    ))}
                  </>
                )}

                {item.business.length > 0 && (
                  <>
                    <div className="text-xl mb-2 mt-1 text-primary">
                      Business
                    </div>
                    {item.business.map((tech, index) => (
                      <Chip
                        key={index}
                        className="mr-2 mb-2"
                        template={techIconContent(tech.imgSrc, tech.label)}
                      />
                    ))}
                  </>
                )}
              </InplaceContent>
            </Inplace>
          </div>
        </div>
      </Card>
    );
  };

  return (
    <div className="card mt-2 mb-2 flex flex-column justify-content-center align-items-center">
      <Timeline
        value={events}
        align={isMobile ? "left" : "alternate"}
        className={isMobile ? "timeline-mobile" : "lg-max-width"}
        marker={customizedMarker}
        content={customizedContent}
      />
      <div className="text-center text-color-secondary mt-2 mb-2">
        Le icone delle tecnologie sono prese da{" "}
        <a href="https://stackshare.io/wilk/" target="_blank" rel="noreferrer">
          Stackshare
        </a>
      </div>
    </div>
  );
}
